import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';

@Injectable()
export class HandlerItemsService {
  private itemsSubject = new BehaviorSubject<InputOrOutputInventory[]>([]);

  // Observable de la lista de items
  public items$ = this.itemsSubject.asObservable();

  // Observable que calcula el total cada vez que los items cambian
  public totalCost$: Observable<number> = this.items$.pipe(
    map((items) => {
      let total = 0;
      for (const item of items) {
        item.totalCost = item.amount * (item.costItem ?? 0);
        total += item.totalCost;
      }
      return total;
    })
  );

  // Observable para formatear el string de total con separador de miles
  public totalLabels$: Observable<string[]> = this.totalCost$.pipe(
    map((total) => {
      return [`Total: $  ${Intl.NumberFormat('es-CO').format(total)}`];
    })
  );

  constructor() {}

  /**
   * Actualiza el valor emitido de los items
   * @param items Arreglo actualizado
   */
  public updateItems(items: InputOrOutputInventory[]): void {
    this.itemsSubject.next([...items]);
  }

  /**
   * Fuerza la re-emisión para que se recalcule el total si hubo mutaciones internas.
   */
  public triggerTotalRecalculation(): void {
    this.itemsSubject.next(this.itemsSubject.value);
  }
}
